
import { reactive, computed, watch, onMounted } from 'vue';
import { uuid } from 'vue-uuid';
export default {
  components: {},
  props: {
    text: {
      type: String,
      default: '',
    },
    selected: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'default'
    },
    layout: {
      type: String,
      default: 'block',  //block : 自己一行 , inline : 多個一行
    },
    isError: {
      type: Boolean,
      default: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    paddingLeft: {
      type: Number,
      default: 28,
    }
  },
  setup(props, { emit }) {
    const { isError, isDisable } = props;
    const state = reactive({
      id: uuid.v4(),
      errorStyle: '',
      disableStyle: isDisable ? 'style--disable' : '',
    })
    const privateSelected = computed({
      get: () => props.selected,
      set: (val) => {
        emit('update:selected', val);
      }
    })
    const onChange = (val) => {
      emit('onChange', val);
      
    }


    const   onClickKeypress = (val) => {
      privateSelected.value = val
    }

    const   onClickRadio = (val) => {
      console.log('@', val)
      emit('onClickRadio', val);
    }


    watch(
      () => props.isError,
      (val) => {
        state.errorStyle = val ? 'style--error' : '';
      })
    watch(
      () => props.isDisable,
      (val) => {
        state.disableStyle = val ? 'style--disable' : '';
      })
    const init = () => {
      state.errorStyle = isError ? 'style--error' : '';
      state.disableStyle = isDisable ? 'style--disable' : '';
    }
    onMounted(() => {
      init();
    })
    return {
      state,
      privateSelected,
      onChange,
      onClickRadio,
      onClickKeypress
      // init
    }
  }// end: setup
}


